import { Tooltip } from "antd";

const ItemHelpButton = ({ title, icon, openModal, disabled = true }) => {
    const alertMateria = () => {
        // message.info("agrega una materia")
    }
    return (
        <Tooltip placement="leftTop" title={<span>{title}</span>} color="#FFFFFF" overlayInnerStyle={{ color: "#3366FF" }}>
            <div
                className={`${disabled ? 'bg-[#9A9A9A]' : 'bg-3366FF'} cursor-pointer flex justify-center
                 items-center w-[32px] h-[32px] rounded-[4px] mb-[24px] shadow-md`}

                onClick={!disabled ? openModal : alertMateria}>
                {/* <div className="w-4 h-4 bg-red-50"> */}
                {icon}
                {/* </div> */}
            </div>
        </Tooltip>
    );
};

export default ItemHelpButton;
